module.exports = __webpack_public_path__ + "static/media/Exam-dark.684678b7.png";